"use client";
import React from "react";
import { Controller, FieldError } from "react-hook-form";
import { WcCheckBox, WcCheckBoxProps, WcFormControl, WcFormControlLabel, WcFormHelperText } from "@bpipartners/webui";

type WcCheckboxControllerProps = {
  name: string;
  control: any;
  label?: string;
  controlDisabled?: boolean;
  onCustomChange?: any;
  error?: FieldError;
} & WcCheckBoxProps;

export const WcCheckboxController = ({
  name,
  control,
  label,
  controlDisabled,
  onCustomChange,
  error,
  ...rest
}: WcCheckboxControllerProps) => {
  if (rest.renderAsButtons) {
    return (
      <WcFormControl>
        <WcFormControlLabel
          control={
            <Controller
              name={name}
              control={control}
              render={({ field: { onChange, value } }) => (
                <WcCheckBox
                  controlDisabled={controlDisabled}
                  value={value}
                  onChange={(event, val) => {
                    if (onCustomChange) {
                      onCustomChange(val);
                    }
                    onChange(val);
                  }}
                  {...rest}
                />
              )}
            />
          }
          label={label}
        />
        <WcFormHelperText>{error ? error.message : ""}</WcFormHelperText>
      </WcFormControl>
    );
  }

  return (
    <WcFormControl>
      <WcFormControlLabel
        control={
          <Controller
            name={name}
            render={({ field: { onChange, value } }) => (
              <WcCheckBox
                controlDisabled={controlDisabled}
                checked={value}
                onChange={(event, checked) => {
                  if (onCustomChange) {
                    onCustomChange(checked);
                  }
                  onChange(checked);
                }}
                {...rest}
              />
            )}
            control={control}
          />
        }
        label={label}
      />
      <WcFormHelperText>{error ? error.message : ""}</WcFormHelperText>
    </WcFormControl>
  );
};
